module.exports = __webpack_public_path__ + "static/media/ashmore-ellis-loop-2.2a197ea2.mp4";